import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiFetch } from '../api';
import './Login.css';

export default function Login() {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setErr('');
    setLoading(true);
    try {
      const data = await apiFetch('/api/auth/login', {
        method: 'POST',
        body: { identifier, password },
      });
      localStorage.setItem('token', data.token);
      localStorage.setItem('nickname', data.user?.nickname || '');
      nav('/'); // 登录成功回到首页
    } catch (e2) {
      setErr('登录失败：' + (e2?.message || ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-card">
        <header className="login-header">
          <div className="brand">
            <div className="brand-logo" aria-hidden>✦</div>
            <div className="brand-text">
              <h1>欢迎回来</h1>
              <p>用一则灵感，开启高效的一天</p>
            </div>
          </div>
        </header>

        <form className="login-form" onSubmit={onSubmit} autoComplete="on">
          <div className="field">
            <input
              id="identifier"
              name="identifier"
              placeholder=" "
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
              autoFocus
              inputMode="email"
            />
            <label htmlFor="identifier">邮箱或手机号</label>
          </div>

          <div className="field">
            <input
              id="password"
              name="password"
              placeholder=" "
              type={showPwd ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="password">密码</label>
            <button
              type="button"
              className="toggle-pwd"
              onClick={() => setShowPwd((v) => !v)}
              aria-label={showPwd ? '隐藏密码' : '显示密码'}
              title={showPwd ? '隐藏密码' : '显示密码'}
            >
              {showPwd ? '🙈' : '👁️'}
            </button>
          </div>

          {err && <div className="error">{err}</div>}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading || !identifier.trim() || !password.trim()}
          >
            {loading ? <span className="spinner" aria-hidden /> : <span className="btn-text">登录</span>}
          </button>

          <div className="links">
            <span className="muted">没有账号？</span>
            <Link to="/register" className="link-underline">去注册</Link>
            <span className="dot">·</span>

          </div>
        </form>

      </section>
    </main>
  );
}
